/**
 * RainbowIcon.jsx — inline SVG icons carrying their own gradient defs.
 *
 * NOTE: two dedicated components on purpose. The codebase's JSX
 * visual-editor plugin wraps React.Fragment children AND JSX ternaries
 * with a `<span data-ve-dynamic>` that becomes invalid HTML inside an
 * SVG root and stops the rects/paths from painting. Each stop and each
 * shape is a direct JSX child (no fragments, no ternaries) so the
 * plugin has nothing to wrap.
 */

export function RainbowDashboardIcon({ className = "w-5 h-5", strokeWidth = 2 }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="rainbow-dashboard" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0%"   stopColor="#ff2d55" />
          <stop offset="20%"  stopColor="#ff9500" />
          <stop offset="40%"  stopColor="#ffcc00" />
          <stop offset="60%"  stopColor="#34c759" />
          <stop offset="80%"  stopColor="#00c8ff" />
          <stop offset="100%" stopColor="#af52de" />
        </linearGradient>
      </defs>
      <rect stroke="url(#rainbow-dashboard)" x="2" y="3" width="20" height="14" rx="2" />
      <path stroke="url(#rainbow-dashboard)" d="M9 21h6" />
      <path stroke="url(#rainbow-dashboard)" d="M12 17v4" />
      <circle stroke="url(#rainbow-dashboard)" cx="7.6" cy="10" r="2.9" />
      <path stroke="url(#rainbow-dashboard)" d="M7.6 10V7.1" />
      <path stroke="url(#rainbow-dashboard)" d="M7.6 10l2.7 1" />
      <path stroke="url(#rainbow-dashboard)" d="M13.4 13.3V11" />
      <path stroke="url(#rainbow-dashboard)" d="M16 13.3V9.4" />
      <path stroke="url(#rainbow-dashboard)" d="M18.6 13.3V7.8" />
    </svg>
  );
}

export function RainbowBriefcaseIcon({ className = "w-5 h-5", strokeWidth = 2 }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="rainbow-briefcase" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0%"   stopColor="#ff2d55" />
          <stop offset="20%"  stopColor="#ff9500" />
          <stop offset="40%"  stopColor="#ffcc00" />
          <stop offset="60%"  stopColor="#34c759" />
          <stop offset="80%"  stopColor="#00c8ff" />
          <stop offset="100%" stopColor="#af52de" />
        </linearGradient>
      </defs>
      <rect stroke="url(#rainbow-briefcase)" width="20" height="14" x="2" y="7" rx="2" ry="2" />
      <path stroke="url(#rainbow-briefcase)" d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  );
}
